import { render, staticRenderFns } from "./selcetDrow.vue?vue&type=template&id=081fd156&scoped=true&"
import script from "./selcetDrow.vue?vue&type=script&lang=js&"
export * from "./selcetDrow.vue?vue&type=script&lang=js&"
import style0 from "./selcetDrow.vue?vue&type=style&index=0&id=081fd156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fd156",
  null
  
)

export default component.exports